import { createContext, useContext } from 'react'

export interface TabContextState {
  isFullWidth: boolean
}

const TabContext = createContext<TabContextState>({ isFullWidth: false })
TabContext.displayName = 'TabContext'

export const TabProvider = TabContext.Provider
export function useTabContext() {
  return useContext(TabContext)
}
